type EventLike = {
  type?: string;
  created_at?: string;
};

const SUPPLEMENT_EVENT_TYPES = new Set(['supplement_assigned', 'supplement_removed', 'supplement_updated']);

export function isSupplementEvent(type?: string): boolean {
  return !!type && SUPPLEMENT_EVENT_TYPES.has(type);
}

export function countUnreadSupplementChanges(events: EventLike[], lastSeenIso: string): number {
  return (events || []).filter((e) => {
    if (!isSupplementEvent(e.type)) return false;
    const createdAt = e.created_at || '';
    return createdAt > lastSeenIso;
  }).length;
}

export function isFormAssignmentEvent(type?: string): boolean {
  return type === 'form_assigned';
}

export function countUnreadFormAssignments(events: EventLike[], lastSeenIso: string): number {
  return (events || []).filter((e) => {
    if (!isFormAssignmentEvent(e.type)) return false;
    const createdAt = e.created_at || '';
    return createdAt > lastSeenIso;
  }).length;
}
